import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import EntryFields from "@/components/EntryFields";
import { format } from "date-fns";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function EntryForm({ helpers, workTypes, onCreated }) {
  const [date, setDate] = useState(new Date());
  const [helper, setHelper] = useState("");
  const [hours, setHours] = useState("8");
  const [workType, setWorkType] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!date) return toast.error("Bitte ein Datum wählen.");
    if (!helper.trim()) return toast.error("Bitte einen Helfer auswählen.");
    if (!workType.trim()) return toast.error("Bitte die Art der Bauarbeiten angeben.");

    setSaving(true);
    try {
      await api.post("/entries", {
        date: format(date, "yyyy-MM-dd"),
        helper_name: helper.trim(),
        hours: parseInt(hours, 10),
        work_type: workType.trim(),
      });
      toast.success("Eintrag gespeichert.");
      setHelper("");
      setWorkType("");
      setHours("8");
      setDate(new Date());
      onCreated();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card className="p-5 sm:p-6 lg:p-8 bg-white border-[#E2E2E2] rounded-xl" data-testid="entry-form-card">
      <h2 className="font-heading text-xl sm:text-2xl text-[#E6017D]">Neuer Eintrag</h2>
      <p className="text-sm text-[#5F6368] mt-1">Bautag dokumentieren</p>

      <form onSubmit={submit} className="mt-6 space-y-4 sm:space-y-5">
        <EntryFields
          date={date} setDate={setDate}
          hours={hours} setHours={setHours}
          helper={helper} setHelper={setHelper}
          workType={workType} setWorkType={setWorkType}
          helpers={helpers} workTypes={workTypes}
        />
        <div className="pt-2">
          <Button type="submit" disabled={saving} data-testid="entry-submit-button"
            className="w-full sm:w-auto h-11 px-8 bg-[#E6017D] hover:bg-[#C4016A] text-white transition-colors">
            {saving ? <Loader2 className="animate-spin" size={18} /> : "Eintrag speichern"}
          </Button>
        </div>
      </form>
    </Card>
  );
}
